const initialState = {
    singIn: false,
    global: true,
    users: false,
    user: true,
    updateUser: false,
    removeUserPoint: false,
    register: false,
    cities: true,
    addCity: false,
    addFilial: false,
    addZone: false,
    city: true,
    zone: true,
    zones: true,
    editCity: false,
    editZone: false,
    orders: false,
    ordersOfHead: false,
    updateorder: false,
    updateMarkedCodes: false,
    settings: true,
    promocodes: false,
    categories: true,
    chanels: true,
    message: false,
    news: true,
    addNews: false,
    goods: true,
    sliders: true,
    addSlider: false,
    updateSlider: null,
    deleteSlider: null,
    yookassa: true,
    addKassa: false,
    updateKassa: null,
    deleteKassa: null,
    category: true,
    modalCategory: false,
    modalGood: false,
    updateGood: null,
    deleteGood: null,
    detailGood: true,
    modalRegionPrice: false,
    updateRegionPrice: null,
    deleteRegionPrice: null,
    modalModification: false,
    updateModification: null,
    deleteModification: null,
    cashbackLogsUser: false,
    ips: true,
    updateIps: null,
    deleteIps: null,
    phonecodes: true,
    promotions: true,
    loadingFilialsNewOrder: false,
    loadingSaveOrder: false,
    payment: true,
    addPayment: false,
    editPayment: false,
    historyOrders: false,
    blockedPhones: false,
    blockedPhonesImport: false,
    blockedPhonesExport: false,
    webhooks: false,
    downloadRobovoiceCallByCall: false,
    couriers: false,
    tag: true,
    addTag: false,
    editTag: false,
    articleCash: true,
    articlesCash: true,
    addArticleCash: false,
    editArticleCash: false,
    articleExpenditures: true,
    addArticleExpenditures: false,
    editArticleExpenditures: false,
    workingShift: false,
    otherExpenditures: false,
    devices: false,
    device: false,
    addDevice: false,
    orderPromo: false,
    invoices: false,
    invoice: false,
    writeoffs: false,
    writeoff: false,
    modalRecipe: false,
    receipesImport: false,
    sources: true,
    addSource: false,
    editSource: false,
    revenuestaff: false,
    wages: false,
    filials: false,
    staff: false,
};

export default function loaders(state = initialState, action) {
  switch(action.type) {
      case 'SET_LOADER': {
          return {
              ...state,
              [action.field]: action.value
          };
      }
    default: return state;
  }
}